import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { InvestigationFormRepository } from '../../../infrastructure/repositories/investigation-form.repository';
import { GetInvestigationFormsWithPagingQuery } from './get-investigation-forms-with-paging.query';
import { GetInvestigationFormsWithPagingResult } from './get-investigation-forms-with-paging.result';
import { InvestigationFormState } from '../../states/investigation-form.state';

@Injectable({ providedIn: 'root' })
export class GetInvestigationFormsWithPagingUseCase {
  private readonly _repository = inject(InvestigationFormRepository);
  private readonly _state = inject(InvestigationFormState);

  public execute(query: GetInvestigationFormsWithPagingQuery): Observable<GetInvestigationFormsWithPagingResult> {
    return this._repository.getInvestigationFormsWithPaging(query).pipe(
      map((result) => {
        this._state.setInvestigationForms(result.data);
        this._state.setInvestigationFormsCount(result.totalElements);
        return {
          data: this._state.investigationForms(),
          totalElements: result.totalElements,
        };
      }),
    );
  }
}
